module.exports = __webpack_public_path__ + "static/media/silver-medal.f2356c4b.png";